import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  calculateTotalPrice,
  getPercentage,
  getToken,
  getUserDetails,
} from "../../resources/helper/helper.js";
import { createOrder } from "../../redux/features/orderSlice.js";
import { toast } from "react-toastify";
import { Box, CircularProgress, Modal } from "@mui/material";
import { clearCart } from "../../redux/features/cartSlice.js";
import PaymentForm from "../Stripe/PaymentForm.jsx";
import { useNavigate } from "react-router-dom";

export default function Checkout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = getToken();
  const { cart } = useSelector((state) => state.cart);
  const { orderLoading } = useSelector((state) => state.order);
  const [open, setOpen] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [selectedPayment, setSelectedPayment] = useState("COD");
  const [credentials, setCredentials] = useState({
    firstName: "",
    lastName: "",
    email: "",
    address: "",
    phoneNumber: "",
    additionalInfo: "",
  });

  const handleRadioChange = (event) => {
    setSelectedPayment(event.target.value);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const data = getUserDetails();
    if (data) {
      const { email, firstName, lastName, phoneNumber } = getUserDetails();
      setUserDetails({ email, firstName, lastName, phoneNumber });
    }
  }, []);

  useEffect(() => {
    if (userDetails) {
      setCredentials({ ...userDetails, address: "", additionalInfo: "" });
    }
  }, [userDetails]);

  const handleInputChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };
  const getProductIds = () => {
    const ids = cart.map((item) => item._id);
    console.log("ids", ids);
    return ids;
  };

  const getProductInfo = () => {
    const productInfo = cart.map((item) => ({
      productId: item?._id,
      vendorId: item?.vendor?._id,
      quantity: item?.quantity,
    }));
    return productInfo;
  };

  const handleOrder = () => {
    // handleOpen();
    if (token) {
      const payload = {
        token,
        orderData: {
          productIds: getProductIds(),
          address: credentials.address,
          firstName: credentials?.firstName,
          lastName: credentials?.lastName,
          email: credentials?.email,
          phone: credentials?.phoneNumber,
          info: credentials?.additionalInfo,
          total: calculateTotalPrice(cart),
          paymentType: selectedPayment,
          productInfo: getProductInfo(),
        },
      };
      dispatch(createOrder(payload))
        .unwrap()
        .then(() => {
          toast.success("Order Created successfully!", {
            position: "top-center",
            theme: "colored",
          });
          const data = {
            products: cart,
            address: credentials.address,
            firstName: credentials?.firstName,
            lastName: credentials?.lastName,
            email: credentials?.email,
            phone: credentials?.phoneNumber,
            total: calculateTotalPrice(cart),
            paymentType: selectedPayment,
          };
          navigate("/invoice", { state: data });
          dispatch(clearCart());
        })
        .catch((err) => {
          toast.error(err, {
            position: "top-center",
            theme: "colored",
          });
        });
    }
  };
  const handleDetailsNavigation = (product) => {
    navigate("/productDetails", { state: product });
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    borderRadius: 4,
    bgcolor: "#fff",
    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  };

  return (
    <div>
      <main className="main">
        <div className="page-header breadcrumb-wrap">
          <div className="container">
            <div className="breadcrumb">
              <a rel="nofollow">
                <i className="fi-rs-home mr-5" />
                Home
              </a>
              <span /> Shop
              <span /> Checkout
            </div>
          </div>
        </div>
        <div className="container mb-80 mt-50">
          <div className="row">
            <div className="col-lg-8 mb-40">
              <h1 className="heading-2 mb-10">Checkout</h1>
              <div className="d-flex justify-content-between">
                {cart && cart?.length > 0 ? (
                  <h6 className="text-body">
                    There are <span className="text-brand">{cart?.length}</span>{" "}
                    products in your cart
                  </h6>
                ) : (
                  <h6 className="text-muted">Your cart is empty</h6>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="border p-40 cart-totals mb-50">
                <div className="d-flex align-items-end justify-content-between mb-30">
                  <h4>Your Order</h4>
                  <h5>
                    Total:{" "}
                    <span className="text-brand">
                      Rs.{calculateTotalPrice(cart)}
                    </span>
                  </h5>
                </div>
                <div className="divider-2 mb-30" />
                <div
                  className="table-responsive order_table checkout"
                  style={{ maxHeight: 450, overflowY: "auto" }}
                >
                  <table className="table no-border">
                    <tbody>
                      {cart && cart?.length > 0 ? (
                        cart?.map((item) => (
                          <tr>
                            <td className="image product-thumbnail">
                              <img src={item?.featured_media} alt="#" />
                            </td>
                            <td>
                              <h6
                                className="w-160 mb-5"
                                onClick={() => handleDetailsNavigation(item)}
                              >
                                <a className="text-heading">{item?.name}</a>
                              </h6>
                              <div className="product-rate-cover">
                                <div className="product-rate d-inline-block">
                                  <div
                                    className="product-rating"
                                    style={{
                                      width: `${getPercentage(
                                        item?.ratings?.averageRating
                                      )}%`,
                                    }}
                                  ></div>
                                </div>
                                <span className="font-small ml-5 text-muted">
                                  {item?.ratings?.averageRating
                                    ? item?.ratings?.averageRating
                                    : 0}
                                </span>
                              </div>
                            </td>
                            <td>
                              <h6 className="text-muted pl-20 pr-20">
                                x {item?.quantity}
                              </h6>
                            </td>
                            <td>
                              <h4 className="text-brand">
                                Rs.{item?.discount_price}
                              </h4>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <h5 className="text-muted">Your cart is empty</h5>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="row"
                style={{
                  background: "#fff",
                  padding: "20px",
                  borderRadius: "10px",
                  boxShadow: "0 0 15px rgba(0, 0, 0, 0.1)",
                }}
              >
                <h4 className="mb-30" style={{ color: "#2C3E50" }}>
                  Billing Details
                </h4>
                <div className="row">
                  <div className="form-group col-lg-6">
                    <input
                      type="text"
                      required
                      name="firstName"
                      value={credentials?.firstName}
                      onChange={handleInputChange}
                      placeholder="First name *"
                      style={{
                        borderRadius: "5px",
                        border: "1px solid #ced4da",
                        padding: "10px",
                        width: "100%",
                        marginBottom: "15px",
                        fontSize: "16px",
                        color: "#495057",
                      }}
                    />
                  </div>
                  <div className="form-group col-lg-6">
                    <input
                      type="text"
                      required
                      name="lastName"
                      value={credentials?.lastName}
                      onChange={handleInputChange}
                      placeholder="Last name *"
                      style={{
                        borderRadius: "5px",
                        border: "1px solid #ced4da",
                        padding: "10px",
                        width: "100%",
                        marginBottom: "15px",
                        fontSize: "16px",
                        color: "#495057",
                      }}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="form-group col-lg-12">
                    <input
                      type="text"
                      name="address"
                      value={credentials?.address}
                      onChange={handleInputChange}
                      required
                      placeholder="Address *"
                      style={{
                        borderRadius: "5px",
                        border: "1px solid #ced4da",
                        padding: "10px",
                        width: "100%",
                        marginBottom: "15px",
                        fontSize: "16px",
                        color: "#495057",
                      }}
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="form-group col-lg-6">
                    <input
                      required
                      type="text"
                      name="email"
                      value={credentials?.email}
                      onChange={handleInputChange}
                      placeholder="Email address *"
                      style={{
                        borderRadius: "5px",
                        border: "1px solid #ced4da",
                        padding: "10px",
                        width: "100%",
                        marginBottom: "15px",
                        fontSize: "16px",
                        color: "#495057",
                      }}
                    />
                  </div>
                  <div className="form-group col-lg-6">
                    <input
                      required
                      type="text"
                      name="phoneNumber"
                      value={credentials?.phoneNumber}
                      onChange={handleInputChange}
                      placeholder="Phone *"
                      style={{
                        borderRadius: "5px",
                        border: "1px solid #ced4da",
                        padding: "10px",
                        width: "100%",
                        marginBottom: "15px",
                        fontSize: "16px",
                        color: "#495057",
                      }}
                    />
                  </div>
                </div>

                <div className="form-group mb-30">
                  <textarea
                    rows={5}
                    name="additionalInfo"
                    value={credentials?.additionalInfo}
                    onChange={handleInputChange}
                    placeholder="Additional information"
                    style={{
                      borderRadius: "5px",
                      border: "1px solid #ced4da",
                      padding: "10px",
                      width: "100%",
                      fontSize: "16px",
                      color: "#495057",
                    }}
                  />
                </div>
                <div style={{}}>
                  <h5>Select Payment Method:</h5>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      gap: 30,
                    }}
                  >
                    <label
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        gap: 10,
                      }}
                    >
                      <input
                        type="radio"
                        value="COD"
                        checked={selectedPayment === "COD"}
                        onChange={handleRadioChange}
                        style={{ width: 20, accentColor: "purple" }}
                      />
                      Cash On Delivery
                    </label>
                    <br />
                    <label
                      style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        gap: 10,
                      }}
                    >
                      <input
                        type="radio"
                        value="STRIPE"
                        checked={selectedPayment === "STRIPE"}
                        onChange={handleRadioChange}
                        style={{ width: 20, accentColor: "purple" }}
                      />
                      Stripe
                    </label>
                  </div>
                </div>
                {selectedPayment === "COD" && (
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <button
                      className="btn btn-fill-out btn-block w-50 mt-20"
                      onClick={handleOrder}
                      style={{
                        color: "#fff",
                        padding: "10px 20px",
                        borderRadius: "5px",
                        fontSize: "16px",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      {orderLoading ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : (
                        "Place an Order"
                      )}
                      {!orderLoading && <i className="fi-rs-sign-out ml-15" />}
                    </button>
                  </div>
                )}
                {selectedPayment === "STRIPE" && (
                  <PaymentForm
                    cart={cart}
                    credentials={credentials}
                    selectedPayment={selectedPayment}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
